import Etiqueta from '../../../components/3catinfo/Etiqueta';
import __isEmpty from 'lodash/isEmpty';

const mergeAgrupacionsTags = ({ agrupacions, tags }) => {
    const arrAgrupacions = Array.isArray(agrupacions) ? agrupacions : [];
    const arrTags = Array.isArray(tags) ? tags : [];
    return [...arrTags, ...arrAgrupacions];
};

const Etiquetes = (props) => {
    const { id, className, exclou } = props;
    const arrEtiquetes = mergeAgrupacionsTags(props);

    const etiquetes = [
        { id: 'ENDIRECTE', icona: 'directes', tipus: 'highlight', text: 'En directe', isBlanc: true },
        { id: 'ULTIMAHORA', tipus: 'highlight', text: 'Última hora' },
        { id: 'ANALISIS', tipus: 'outstanding' }
    ];

    const filteredAgrupacions = arrEtiquetes.filter((item) => !exclou?.split(',').includes(item.id));
    const etiquetaItem = etiquetes.find((etiqueta) => filteredAgrupacions?.some((item) => item.id === etiqueta.id));

    if (!__isEmpty(etiquetaItem)) {
        return (
            <>
                <Etiqueta
                    key={`etiqueta-${id}-${etiquetaItem.id}`}
                    text={
                        etiquetaItem.text ||
                        filteredAgrupacions?.find((item) => item.id === etiquetaItem.id && etiquetaItem.showText !== false)?.desc
                    }
                    icona={etiquetaItem.icona}
                    tipus={etiquetaItem.tipus}
                    estil={etiquetaItem.estil}
                    isBlanc={etiquetaItem.isBlanc}
                    className={className}
                />
            </>
        );
    } else {
        return <></>;
    }
};

export default Etiquetes;
